Application.Forms.RadioImages = {
    ui: {
        container: '.js-radio-images',
        item: '.js-radio-images__item',
        link: '.js-radio-images__link',
        input: '.js-radio-images__input',
    },
    classes: {
        active: 'form-radio-images__item_active',
    },
    ready: function () {

        var self = this;

        this.bind();

        // init
        $(this.ui.container).each(function(){
            self.init(this);
        });

    },
    bind: function(){

        var self = this;

        $(this.ui.link).on('click', function(event){
            event.preventDefault();
            self.activate(this);
        });

    },
    init: function(el){

        var self = this;
        var $links = $(el).find(this.ui.link);
        var found = false;

        // activate an option by input value
        $links.each(function(){
            var $container = $(this).closest(self.ui.container);
            if ($(this).data('value') == self.getValue($container)){
                found = true;
                self.activate(this);
                return false;
            }
        });

        // no option found, activate first
        if (!found){
            this.activate($links.first());
        }

    },
    activate: function(link){

        var $link = $(link);
        // redraw
        $link.closest(this.ui.container).find(this.ui.item).removeClass(this.classes.active);
        $link.closest(this.ui.item).addClass(this.classes.active);
        // set input value
        this.setValue($link.closest(this.ui.container), $link.data('value'));

    },
    // *** INPUT ***
    get$Input: function (container) {

        return $(container).find(this.ui.input);

    },
    getValue: function (container) {

        return this.get$Input(container).val();

    },
    setValue: function (container, value) {

        this.get$Input(container).val(value).trigger('change');

    }
}